import { FC, ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import PanelHeader from '@/components/sidebar/stickyPanelHeader/PanelHeader';
import { Button } from '@/components/UI/Button/Button';
import useLogger from '@/hooks/useLogger';

import styles from './SidebarPanelErrorBoundary.module.css';

type SidebarPanelErrorBoundaryProps = {
  title: string;
  sectionId: string;
  children: ReactNode;
};

const SidebarPanelErrorBoundary: FC<SidebarPanelErrorBoundaryProps> = ({ title, sectionId, children }) => {
  const log = useLogger();

  return (
    <ErrorBoundary
      onError={(error, info) => {
        const message = error instanceof Error ? error.message : 'Onbekende fout';
        const errorDetails = `[MWD ${sectionId}] ${message}\n${info.componentStack ?? ''}`;
        console.error(errorDetails);
        log(errorDetails, true);
      }}
      fallbackRender={({ resetErrorBoundary }) => (
        <section className={styles.fallbackStyle} aria-label={`${title} foutmelding`}>
          <PanelHeader title={title} sectionId={sectionId} />
          <div className={styles.contentStyle}>
            <p role='alert' className={styles.messageStyle}>
              {title} kan niet worden weergegeven.
            </p>
            <Button
              size='medium'
              className={styles.retryStyle}
              aria-label={`${title} opnieuw proberen`}
              onClick={() => resetErrorBoundary()}
            >
              Opnieuw proberen
            </Button>
          </div>
        </section>
      )}
    >
      {children}
    </ErrorBoundary>
  );
};

export default SidebarPanelErrorBoundary;
